import { useSelector } from 'react-redux';
import { RefObject } from 'preact';
import { useRef } from 'preact/hooks';
import { useStyles } from '../../../common/hooks/useStyles';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { getStoriesTitleStyleObject } from './storiesTitle.style';
import { adsDataSelector } from '../../../common/store/selectors/adsData.selector';
import { TitleLine, useResizeStoriesTitle } from '../../../common/hooks/useResizeStoriesTitle';
import { css } from '../../../common/styles/styles.utils';

const getPreviousWordsAmount = (titleByLines: Array<TitleLine>, lineIndex: number): number => {
  return titleByLines.slice(0, lineIndex).reduce((prev: number, curr: TitleLine) => {
    return prev + curr.text.length;
  }, 0);
};

export const StoriesTitle = () => {
  const playerSize = useSelector(playerDataSelector.playerSize);
  const videoTagStatus = useSelector(playerDataSelector.videoTagStatus);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const isVastAd = useSelector(adsDataSelector.isVastAd);

  const storiesTitleElementRef: RefObject<Array<HTMLSpanElement>> = useRef([]);
  const titleWrapperElementRef: RefObject<HTMLDivElement> = useRef(null);

  const showAdControls = isVastAd && adBreak;
  const videoLoading = videoTagStatus === 'unloaded' || videoTagStatus === 'idle' || videoTagStatus === 'seeking';
  const showStoryTitle = !videoLoading && !showAdControls;

  const { titleByLines, isFullTitleByLines } = useResizeStoriesTitle(storiesTitleElementRef.current, titleWrapperElementRef.current);

  const styles = useStyles(getStoriesTitleStyleObject, [showStoryTitle, playerSize, isFullTitleByLines]);
  const { titleWrapperStyle, titleLineWrapperStyle, titleLineStyle, getSingleWordStyle } = styles;

  return (
    <div style={css(titleWrapperStyle)} ref={titleWrapperElementRef}>
      {titleByLines.map((titleLine, lineIndex) => (
        <div style={css(titleLineWrapperStyle)} key={lineIndex}>
          {/* eslint-disable-next-line */}
          <div ref={titleLineRef => storiesTitleElementRef.current[lineIndex] = titleLineRef} style={css(titleLineStyle)}>
            {titleLine.text && titleLine.text.map((singleWord, wordIndex) => (
              <span style={css(getSingleWordStyle(getPreviousWordsAmount(titleByLines, lineIndex) + wordIndex))} key={wordIndex}>
                {`${singleWord}\u00A0`}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
